import type { QUESTION_RESULT_STATUSES, Question } from "models";

export enum QUESTION_LISTS {
  Dealer = "dealer",
  Default = "default"
}

export type QuestionElementConfiguration = {
  label?: string;
  default_value?: string;
  optional_answers?: string[];
  items?: { label: string }[];
  unit?: string;
  digits?: string;
  decimals?: string;
  unit_items?: { label: string }[];
  value_items?: { label: string }[];
  type_items?: { label: string }[];
  disabled_statuses?: QUESTION_RESULT_STATUSES[];
};

export const sortQuestionsByNewest = (questions: Question[]) => questions.toSorted((a, b) => b.id - a.id);

export const getElementConfiguration = (defaultConfiguration: string): QuestionElementConfiguration => {
  try {
    return JSON.parse(defaultConfiguration) ?? {};
  } catch {
    return {};
  }
};
